<script>
import Select from "../Components/Select.vue";
import DatePicker from "../Components/DatePicker.vue";
import Travelers from "../Components/CIPTravelers.vue";
import { BreakPoints, CIPFlightType, CIPTripType } from "../../../Constants";
import { CIPLocationMapper, CIPFlightTypeMapper } from "../../../Mappers";

export default {
  components: {
    Select,
    DatePicker,
    Travelers,
  },

  data() {
    return {
      locationSearchUrl: null,
      submitData: {
        airport: null,
        flightType: null,
        departureDate: null,
        travelers: null,
      },
      defaultCityList: [],
      defaultFlightTypes: [],
      isLoading: false,
    };
  },

  computed: {
    isFormValid() {
      return Object.values(this.$refs).every((ref) => ref?.isValid);
    },

    datePickerLabel() {
      return this.submitData.flightType
        ? this.submitData.flightType.flightType === CIPFlightType.arrival.value
          ? "تاریخ ورود"
          : "تاریخ خروج"
        : "تاریخ";
    },
  },

  methods: {
    CIPLocationMapper,
    CIPFlightTypeMapper,

    handleChangeAirport(airport) {
      this.submitData.flightType = null;
      this.$refs.flightType.handleResetValue();

      if (airport) {
        this.defaultFlightTypes = airport.tripTypes.flatMap((tripType) => {
          return airport.flightTypes.map((flightType) => {
            const title =
              tripType === CIPTripType.international.value
                ? CIPTripType.international.title
                : CIPTripType.domestic.title;
            const typeTitle =
              flightType === CIPFlightType.arrival.value ? CIPFlightType.arrival.title : CIPFlightType.departure.title;

            return {
              title: `${title} / ${typeTitle}`,
              tripType,
              flightType,
              key: `${tripType}-${flightType}`,
            };
          });
        });
      }
    },

    fillNextInput(type) {
      if (window.innerWidth <= BreakPoints.md) return;
      const inputOrder = ["airport", "flightType", "departureDate"];

      const nextInput = inputOrder.find((input) => !this.submitData[input]);
      if (nextInput) {
        this.$refs[nextInput]?.handleOpen();
      }
    },

    validateAllInputs() {
      Object.values(this.$refs).forEach((ref) => ref?.validate());
    },

    buildSearchUrl() {
      const { airport, flightType, departureDate, travelers } = this.submitData;
      const { CIPSearchUrl } = window.bookingSectionInitialize;
      let searchUrl = `${CIPSearchUrl}?ac=${airport.airportCode}&ft=${flightType.flightType}&tt=${flightType.tripType}&adt=${travelers.adult}&cht=${travelers.child}&inf=${travelers.infant}&st=${departureDate}`;
      return searchUrl;
    },

    async handleSearch() {
      this.validateAllInputs();

      if (this.isFormValid) {
        this.isLoading = true;

        try {
          const searchUrl = this.buildSearchUrl();
          window.location.assign(searchUrl);
        } catch (error) {
          console.error("Error during search:", error);
          this.isLoading = false;
        }
      }
    },
  },

  created() {
    if (window.cipAirlines?.length) {
      this.defaultCityList = this.CIPLocationMapper({
        model: window.cipAirlines,
      });
    }

    this.locationSearchUrl = window.bookingSectionInitialize.CIPLocationSearchUrl;
  },
};
</script>

<template>
  <div>
    <div class="booking__main">
      <div class="booking__row">
        <div class="booking__items">
          <div class="booking__location booking__location--cip">
            <Select
              label="نام فرودگاه"
              placeholder="انتخاب نام فرودگاه"
              name="airport"
              v-model="submitData.airport"
              :mapper="CIPLocationMapper"
              :default-list="defaultCityList"
              :get-data-url="locationSearchUrl"
              item-title="airportTitle"
              item-value="airportCode"
              item-icon="icon"
              :on-change-value="handleChangeAirport"
              @fill-next-input="() => fillNextInput('airport')"
              ref="airport"
            />

            <Select
              label="نوع پرواز / نوع سفر"
              placeholder="انتخاب نوع پرواز / نوع سفر"
              name="flightType"
              v-model="submitData.flightType"
              :mapper="CIPFlightTypeMapper"
              :default-list="defaultFlightTypes"
              item-title="title"
              item-value="key"
              @fill-next-input="() => fillNextInput('flightType')"
              ref="flightType"
            />
          </div>

          <div class="booking__date booking__date--sm">
            <DatePicker
              :label="datePickerLabel"
              :placeholder="'انتخاب ' + datePickerLabel"
              v-model="submitData.departureDate"
              @fill-next-input="() => fillNextInput('departureDate')"
              ref="departureDate"
              name="departureDate"
            />
          </div>

          <div class="booking__travelers">
            <Travelers v-model="submitData.travelers" ref="travelers" />
          </div>
        </div>

        <button @click="handleSearch" class="booking__submit btn btn-red" title="جستجو" :disabled="isLoading">
          <span v-if="isLoading" class="bounce-loading bounce-loading--white">
            <span class="bounce1" />
            <span class="bounce2" />
            <span class="bounce3" />
          </span>

          <template v-else>
            <i class="icon-search ml--1" />

            <span>جستجو</span>
          </template>
        </button>
      </div>
    </div>
  </div>
</template>
